<template>
  <Modal ref="modalRef" class="transfer-modal" ok-style="warning" :ok-disabled="!canTransferRef" @shown="onShown" @ok="transferAsync">
    <template #title>Change owner</template>
    <label>Transfer ownership of this {{ groupTypeTextRef }}:</label>
    <ProfileCard v-if="dataGroupRef?.isProfile" show-profile-type static :person-id="dataGroupRef.startItemId"/>
    <ResearchGroupItem v-else :data-group-id="dataGroupId"/>
    <label>to this user:</label>
    <UserSelector ref="userSelectorRef" v-model="toUserIdRef"/>
    <template #okText>Transfer now</template>
  </Modal>
</template>

<style lang="scss" scoped>
:deep(.modal-body) {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.profile-card,
.research-group-item,
.user-selector {
  margin-left: 1rem;
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import Modal from '@/util/Modal.vue'
import ProfileCard from '../ProfileCard.vue'
import ResearchGroupItem from '../researchgroups/ResearchGroupItem.vue'
import UserSelector from '../users/UserSelector.vue'

const props = defineProps<{
  dataGroupId?: string,
}>()

const toUserIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()
const userSelectorRef = ref<InstanceType<typeof UserSelector>>()

const dataGroupStore = useDataGroupStore()

const dataGroupRef = computed(() => dataGroupStore.getLoadedGroup(props.dataGroupId))
const groupTypeTextRef = computed(() => dataGroupRef.value?.isProfile ? 'profile' : 'tree')
const canTransferRef = computed(() => !!toUserIdRef.value)

function onShown() {
  toUserIdRef.value = undefined
  userSelectorRef.value?.clear()
  userSelectorRef.value?.focus()
}

async function transferAsync() {
  try {
    if (props.dataGroupId && toUserIdRef.value) {
      await dataGroupStore.transferAsync(props.dataGroupId, toUserIdRef.value)
      modalRef.value?.close()
    }
  }
  finally {
    modalRef.value?.reset()
  }
}

</script>
